import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { PieChartConfig } from '../../../../../shared/google-chart/Models/PieChartConfig';

@Component({
	selector: 'app-missed-finish-alert',
	templateUrl: './missed-finish-alert.component.html',
	styleUrls: ['./missed-finish-alert.component.css']
})
export class MissedFinishAlertComponent implements OnInit, OnChanges {

	@Input() data: any;
	@Input() siteId: number = 0;
	@Input() customerId: number = 0;
	@Input() customerName: string = '';
	@Input() siteName: string = '';

	config: PieChartConfig;
	tableColumns: any[] = [];
	title: string = 'Missed Finish';
	elementId: string = 'batt_alert_missed_fi';
	widgetClass: string = 'height-530';
	siteWidgetOptions: any = {
		hasDate: true,
		isAlertWidget: true,
		hideYesterdayDate: true
	};

	constructor() { }

	ngOnInit() {
	
		this.config = new PieChartConfig({
			colors: [
				{ color: '#109618' },
				{ color: '#bd2f26' },
			]
		});
		
		this.config.formatFunction = (data) => {
			let formattedData: any[] = [
				[
					{"label": "Name", "type": "string"},
					{"label": "Value", "type": "number"}
				]
			];

			formattedData.push([{v: "No Alerts"}, {v: data.Pie[0].ok}]);
			formattedData.push([{v: "1 Missed Finish or More"}, {v: data.Pie[1].one_or_more}]);
			return formattedData;
		};
	}
	
	ngOnChanges(changes) {
		if(this.data) {
			let tableColumns = [{title: "Battery ID", property: "battery_id"}];
			if (this.data.siteSettings.userSettings.view_truck_id) {
				tableColumns.push({title: "Truck ID", property: "truck_id"});
			}
			tableColumns.push({title: "Expected FI Cycle", property: "expected_finish"});
			tableColumns.push({title: "Actual FI Cycles", property: "actual_finish"});
			this.tableColumns = tableColumns;
		}
	}
}
